import { buildPmsReportPdf, type PmsReportPdfInput } from './pmsReportPdf';
import { loadImageDataUrl } from './dailyLogPdf';

/** Build the PMS report PDF and share it (mobile) or download it (desktop). */
export async function sharePmsReportPdf(input: Omit<PmsReportPdfInput, 'logoDataUrl'>): Promise<'shared' | 'downloaded'> {
  const logoDataUrl = await loadImageDataUrl('/logo.png');
  const blob = await buildPmsReportPdf({ ...input, logoDataUrl });

  const fileName = `PMS-Report_${input.equipmentId}_${input.submissionId.slice(0, 8)}.pdf`;
  const file = new File([blob], fileName, { type: 'application/pdf' });
  const nav = navigator as Navigator & { canShare?: (d: ShareData) => boolean };

  if (nav.canShare && nav.canShare({ files: [file] })) {
    await nav.share({ files: [file], title: `PMS Report — ${input.equipName}` });
    return 'shared';
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = fileName; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
  return 'downloaded';
}
